/**
 * @module support/shared/widgets / Go to the top of the page
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { EventEmitter, Directive, OnChanges, Input, Output, OnInit } from '@angular/core';
// TODO Tslint disabled will be removed once after discussion with foundary team
/* tslint:disable:no-global-variables */
const gcui = document.getElementsByClassName('gcui');

@Directive({
  selector: '[tmoGoToRepdashTop]',
})

/**
 * Directive will navigate to top of the page.
 */
export class ScrollToTopDirective implements OnInit, OnChanges {
  /**
   * Is type of boolean used to navigate at the top of page when true
   */
  @Input() public goToTop: boolean;
  /**
   * Is type of boolean used to check whether channel is web or not
   */
  @Input() public isWebChannel: boolean;
  /**
   * Is type of boolean used to navigate at the top of page when true
   */
  @Output() public scrollCompleted: EventEmitter<boolean>;

  constructor() {
    this.scrollCompleted = new EventEmitter();
  }

  /**
   * Initializes the data for ngOnInit directive.
   * @returns void
   */
  public ngOnInit(): void {
    this.scrollToTop();
  }

  /** On change call scrollToTop method
   * @returns void
   */
  public ngOnChanges(): void {
    this.scrollToTop();
  }

  /**
   * go to the Top of the page.
   * @returns void
   */
  private scrollToTop(): void {
    if (this.goToTop && gcui && gcui.length > 0) {
      gcui[0].scrollTop = 0;
      this.scrollCompleted.emit();
    } else if (this.isWebChannel) {
      window.scrollTo(0, 0);
    }
  }
}
